import { ChatBubble } from '@components/Consultation/steps/Answer/ChatBubble'
import { Download } from '@components/Consultation/steps/Answer/Download'
import { Rating } from '@components/Consultation/steps/Answer/Rating'
import { TakeAgain } from '@components/Consultation/steps/Answer/TakeAgain'
import React, { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'

import { rateConsultation } from '@/api/consultations'
import { useConsultation } from '@/hooks/useConsultation'
import { useLoading } from '@/hooks/useLoading'
import { useStepper } from '@/hooks/useStepper'
import { useUser } from '@/hooks/useUser'
import i18n from '@/locale/i18n'
import { CONSULTATION_STEPS, STEP_STEPPER } from '@/types/consultation'

// TODO this is mocked as medical until be sends consultation type on consultation object
const CURRENT_CONSULTATION_TYPE = 'text'

export const Answer = () => {
  const { t } = useTranslation()
  const { user } = useUser()
  const { updateStep } = useStepper()
  const { consultation, updateConsultation } = useConsultation()
  const { showLoading, hideLoading } = useLoading()

  const [ratingConfirmed, setRatingConfirmed] = useState(false)

  const onConfirmRating = (rating: number) => {
    showLoading()

    rateConsultation({
      rating,
      uniqueId: user?.data?.uniqueId as string
    })
      .then((ratedConsultation) => {
        updateConsultation(ratedConsultation)
        setRatingConfirmed(true)
      })
      .finally(() => {
        hideLoading()
      })
  }

  useEffect(() => {
    updateStep(STEP_STEPPER[CONSULTATION_STEPS.ANSWER])
  }, [])

  return (
    <>
      <div className="flex flex-1 flex-col items-center gap-4 overflow-y-auto p-4" data-testid="answer-container">
        {consultation?.questions.map((question, index) => {
          const { createdAt, question: questionText, answer, professional } = question

          return (
            <React.Fragment key={index}>
              <div className="flex w-full animate-fade-in flex-col items-center gap-2">
                <p className="rounded-2xl bg-white py-2 px-4 text-center text-sm font-bold drop-shadow-chat-bubble">
                  • {t(`general.consultation.${CURRENT_CONSULTATION_TYPE}.title`)}{' '}
                  {new Date(createdAt as number).toLocaleDateString(i18n.language, {
                    year: 'numeric',
                    month: 'long',
                    day: 'numeric'
                  })}{' '}
                  •
                </p>

                <ChatBubble left>
                  <p className="break-words">{questionText}</p>
                </ChatBubble>
              </div>

              {answer && (
                <div className="flex w-full animate-fade-in flex-col items-center gap-2">
                  <p className="text-sm font-bold">
                    •{' '}
                    {t(`professional_title_${professional?.gender}`, {
                      name: professional?.name
                    })}{' '}
                    •
                  </p>

                  <ChatBubble>
                    <p className="break-words">{answer}</p>
                  </ChatBubble>
                </div>
              )}
            </React.Fragment>
          )
        })}

        {ratingConfirmed ? (
          <>
            <p className="w-full animate-fade-in rounded-2xl bg-white py-2 px-4 text-center font-bold drop-shadow-chat-bubble">
              {t('answer.thanks.rating')}
            </p>
            <Download />
          </>
        ) : (
          <Rating onConfirmRating={onConfirmRating} />
        )}
      </div>

      {ratingConfirmed && <TakeAgain />}
    </>
  )
}
